export default "__VITE_ASSET__CRjR8puh__"